import styled from 'styled-components';
import { FaCaretRight, FaCaretLeft } from 'react-icons/fa';

export const PaginationWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  user-select: none;
`;

export const Page = styled.div`
  user-select: none;
  font-size: 18px;
`;

export const PrevButton = styled(FaCaretLeft).attrs({ size: 24 })`
  cursor: pointer;
  user-select: none;
  color: #3babac;
`;

export const NextButton = styled(FaCaretRight).attrs({ size: 24 })`
  cursor: pointer;
  user-select: none;
  color: #3babac;
`;
